export async function uploadFileByUrl({ fileUrl, s3_file_key, onProgress }) {
  try {
    // Start the estimation-based progress
    const estimatedUploadTime = 10000; // 10 seconds, adjust based on your average
    const intervalDuration = 100; // every 100ms
    const increment = (100 * intervalDuration) / estimatedUploadTime;

    let progress = 0;

    const progressInterval = setInterval(() => {
      progress += increment;
      if (progress >= 100) {
        progress = 100;
        clearInterval(progressInterval);
      }
      onProgress(progress);
    }, intervalDuration);

    const response = await fetch('/api/rss-downloader', {
      method: 'POST',
      body: JSON.stringify({ fileUrl, s3_file_key }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Once we get a response from the server, clear the interval
    clearInterval(progressInterval);

    if (!response.ok) {
      onProgress(100);  // Ensure progress is set to 100 even on error
      throw new Error('Error uploading file');
    }

    const data = await response.json();

    // Make sure progress is set to 100 when the upload is done
    onProgress(100);

    return data.key;  // This is the S3 key of the uploaded file

  } catch (error) {
    console.error("Error:", error);
  }
}
